import { Injectable } from '@angular/core';
import { BaseService } from '../../base.service';

import { AttEmployeeDailyDeductionModel, AttEmployeeDailyDeductionResponse } from '../../../../domain/models/Hr-Management/attendance/att-employee-daily-deduction.model';
import { AttEmployeeDailyDeductionRepositoryImplService } from '../../../../infrastructure/repositories/Hr Management/attendance/att-employee-daily-deduction-repository-impl.service';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class AttEmployeeDailyDeductionService extends BaseService<
  AttEmployeeDailyDeductionModel,
  AttEmployeeDailyDeductionResponse
> {
  constructor(private repo: AttEmployeeDailyDeductionRepositoryImplService) {
    super(repo);
  }

  getFiltered(filters: {
    companyId?: string;
    employeeId?: number;
    attendanceDate?: string;
    type?: number;
    attDelayEarlyLeaveId?: number;
    fromDate?: string;
    status?: number;
    toDate?: string;
    page?: number;
    pageSize?: number;
  }) {
    return this.repo.getFiltered(filters);
  }


  /** att_review_01: a percentage set by hand on a 0% "no rule" row (Approve permission). */
  setManualPercent(id: number, percent: number): Observable<AttEmployeeDailyDeductionResponse> {
    return this.repo.setManualPercent(id, percent);
  }

decide(id: number, status: number, note: string, asAdjustment = false): Observable<AttEmployeeDailyDeductionResponse> {
    return this.repo.decide(id, status, note, asAdjustment);
  }

  decideMany(ids: number[], status: number, note: string, asAdjustment = false): Observable<any> {
    return this.repo.decideMany(ids, status, note, asAdjustment);
  }

}

